import { motion } from "framer-motion";
import TestimonialCard from "@/components/ui/testimonial-card";
import { TESTIMONIALS } from "../data/landing";
import { Reveal } from "../components/Reveal";

export default function Testimonials() {
  return (
    <section
      className="relative bg-gradient-to-b from-[#0A1130] via-[#0A1130] to-[#050B26] py-24 sm:py-32 border-t border-white/5"
      data-testid="testimonials-section"
      id="testimonials"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center mb-14">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#1440E1] font-semibold mb-4">
            What Our Clients Say
          </p>
          <h2 className="font-arial-black text-3xl sm:text-4xl lg:text-5xl text-white leading-tight tracking-tight whitespace-normal lg:whitespace-nowrap">
            Real results, in their own words.
          </h2>
        </Reveal>

        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.authorName}
              animate={{ y: [0, -9, 0] }}
              transition={{
                duration: 5 + (i % 3),
                repeat: Infinity,
                ease: "easeInOut",
                delay: (i % 3) * 0.6,
              }}
            >
              <TestimonialCard index={i} {...t} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
